/**
 * Persists the user's light/dark scheme choice across reloads.
 * Mirrors the pattern used by `apply-primary-palette.ts` for the primary color.
 */
const STORAGE_KEY = 'bizcare-scheme';

export type StoredScheme = 'light' | 'dark';

export function readStoredScheme(): StoredScheme | null {
    try {
        const value = localStorage.getItem(STORAGE_KEY);
        return value === 'light' || value === 'dark' ? value : null;
    } catch {
        return null;
    }
}

export function writeStoredScheme(scheme: StoredScheme): void {
    try {
        localStorage.setItem(STORAGE_KEY, scheme);
    } catch {
        /* ignore storage errors (private mode, quota, etc.) */
    }
}

/** Keep html + body in sync (index.html bootstrap sets both; runtime must too). */
export function applySchemeToDocument(
    scheme: StoredScheme,
    doc: Document = document
): void {
    doc.documentElement.classList.remove('light', 'dark');
    doc.body?.classList.remove('light', 'dark');
    doc.documentElement.classList.add(scheme);
    doc.body?.classList.add(scheme);
}
